/* eslint-disable react-refresh/only-export-components */
import { AxiosInstance } from 'axios';
import { createContext } from 'react';

export default createContext({} as AxiosInstance);
